import { Component, type ReactNode } from 'react';
import Alert from '@mui/material/Alert';

interface RemoteErrorBoundaryProps {
  fallbackMessage: string;
  children: ReactNode;
}

interface RemoteErrorBoundaryState {
  failed: boolean;
}

/**
 * Catches load/runtime failures of a federated remote so a missing feature
 * app degrades to an inline alert instead of a white screen.
 */
export class RemoteErrorBoundary extends Component<
  RemoteErrorBoundaryProps,
  RemoteErrorBoundaryState
> {
  state: RemoteErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): RemoteErrorBoundaryState {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return <Alert severity="error">{this.props.fallbackMessage}</Alert>;
    }
    return this.props.children;
  }
}
